import api from './client';

export interface OutstandingInvoice {
  id: number;
  invoice_code: string;
  job_card_id: number;
  invoice_type: string;
  invoice_date: string;
  subtotal: number;
  discount_amount: number;
  taxable_amount: number;
  cgst_rate: number;
  cgst_amount: number;
  sgst_rate: number;
  sgst_amount: number;
  apply_gst: number;
  total_amount: number;
  amount_paid: number;
  balance_due: number;
  card_charges: number;
  status: string;
  created_at: string;
  customer_name: string;
  customer_phone: string;
  job_code: string;
  job_status: string;
  vehicle_name: string;
  vehicle_reg: string;
  days_since: number;
}

export interface CompletedPayment {
  id: number;
  invoice_id: number;
  job_card_id: number;
  customer_id: number;
  payment_type: string;
  amount: number;
  payment_mode: string;
  reference_no: string | null;
  notes: string | null;
  received_by: number;
  payment_date: string;
  created_at: string;
  invoice_code: string;
  invoice_total: number;
  customer_name: string;
  customer_phone: string;
  job_code: string;
  received_by_name: string;
}

export interface PaymentDashboard {
  outstanding: { count: number; total: number };
  today: { count: number; total: number };
  this_month: { count: number; total: number };
  by_mode: Array<{ payment_mode: string; count: number; total: number }>;
}

export const paymentsApi = {
  getDashboard: async (): Promise<PaymentDashboard> => {
    const { data } = await api.get('/payments/dashboard');
    return data.data;
  },

  getOutstanding: async (params?: Record<string, any>): Promise<OutstandingInvoice[]> => {
    const { data } = await api.get('/payments/outstanding', { params });
    return data.data;
  },

  getCompleted: async (params?: Record<string, any>) => {
    const { data } = await api.get('/payments/completed', { params });
    return data;
  },

  getAll: async (params?: Record<string, any>) => {
    const { data } = await api.get('/payments', { params });
    return data;
  },

  getById: async (id: number) => {
    const { data } = await api.get(`/payments/${id}`);
    return data.data;
  },

  recordPayment: async (payload: {
    invoice_id: number;
    amount: number;
    settle_amount?: number;
    payment_mode?: string;
    reference_number?: string;
    notes?: string;
  }) => {
    const { data } = await api.post('/payments', payload);
    return data.data;
  },

  getSummary: async () => {
    const { data } = await api.get('/payments/summary/overview');
    return data.data;
  },
};
